import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { createTotp, fetchTwoFactorCode } from 'redux/users/actions';

import Parser from 'html-react-parser';

import Button from 'components/elements/buttons/Button';

import './TwoFactorCode.css';

function TwoFactorCode(props) {
  const {
    onClose,
    setActiveStep,
    createTotp,
    fetchTwoFactorCode,
    createTtopSuccess,
    createTtopError,
    twoFactorCode,
    twoFactorCodeError,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    createTotp();
  }, []);

  useEffect(() => {
    if (createTtopSuccess) {
      fetchTwoFactorCode();
    }
  }, [createTtopSuccess]);

  const qrCode = twoFactorCode && twoFactorCode.qr_code &&
    Parser(twoFactorCode.qr_code.replace('<?xml version=\'1.0\' encoding=\'UTF-8\'?>', ''));
  const encodeKey = twoFactorCode && twoFactorCode.encode_key;

  if (!qrCode || !encodeKey) return null;

  return (
    <div className="two-factor-code__component">
      <div className="text">
        <div><strong>{t("Set up via Third Party Authenticator.")}</strong></div>
        {t("Please use authentication app Google Authenticator to scan this QR code.")}
      </div>

      {qrCode &&
        <div className="qr-code">
          {qrCode}
        </div>
      }

      <div className="text">
        {t("Or enter this code into your authentication app")}
      </div>

      {encodeKey &&
        <div className="encode-key">
          <div>{encodeKey.slice(0, 4)}</div>
          <div>{encodeKey.slice(4, 8)}</div>
          <div>{encodeKey.slice(8, 12)}</div>
          <div>{encodeKey.slice(12, 16)}</div>
          <div>{encodeKey.slice(16, 20)}</div>
          <div>{encodeKey.slice(20, 24)}</div>
          <div>{encodeKey.slice(24, 28)}</div>
          <div>{encodeKey.slice(28, 32)}</div>
        </div>
      }

      <div className="buttons-block">
        <Button
          small
          onClick={() => { setActiveStep('confirmation'); }}
        >
          {t("Continue")}
        </Button>
        <Button small borderedBlue onClick={onClose}>{t("Cancel")}</Button>
      </div>

    </div>
  );
}

TwoFactorCode.propTypes = {
  createTotp: PropTypes.func.isRequired,
  fetchTwoFactorCode: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

TwoFactorCode.defaultProps = {
  createTtopSuccess: null,
  createTtopError: null,
  twoFactorCode: null,
  twoFactorCodeError: null,
};

const mapStateToProps = state => (
  {
    createTtopSuccess: state.usersReducer.createTtopSuccess,
    createTtopError: state.usersReducer.createTtopError,
    twoFactorCode: state.usersReducer.twoFactorCode,
    twoFactorCodeError: state.usersReducer.twoFactorCodeError,
  }
);

export default connect(
  mapStateToProps,
  {
    createTotp,
    fetchTwoFactorCode,
  },
)(TwoFactorCode);
